var map = {
	"./asbestosL1.png": 1607,
	"./asbestosL2.png": 1608,
	"./asbestosL3.png": 1609,
	"./asbestosLS.png": 1610,
	"./bccsla.png": 1611,
	"./coreacert.png": 1612,
	"./coria.png": 1613,
	"./dust.png": 1614,
	"./emm.png": 1615,
	"./hma.png": 1616,
	"./lse.png": 1617,
	"./mmw.png": 1618,
	"./ncso-ihsa.png": 1619,
	"./ncso.png": 1620,
	"./nhsa-ihsa.png": 1621,
	"./nhsa.png": 1622,
	"./pcr.png": 1623,
	"./phsm.png": 1624,
	"./pim.png": 1625,
	"./tst.png": 1626,
	"./whmis.png": 1627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1606;